<template>
  <div class="calendar">
    <div class="calendar-header">
      <van-icon class="arrow arrow-left" name="arrow-left" @click="prevMonth" />
      <span>{{ currentYear }}年{{ currentMonth }}月</span>
      <van-icon class="arrow arrow-right" name="arrow" @click="nextMonth" />
    </div>
    <div class="calendar-body">
      <div class="weekdays">
        <div v-for="(day, index) in weekdays" :key="index" :class="['weekday', { 'selected': isSelectedWeekday(day) }]">
          <span>{{ day }}</span>
          <span>{{ enWeekdays[index] }}</span>
        </div>
      </div>
      <div class="days">
        <div
          v-for="(day, index) in days"
          :key="index"
          :class="['day', { 'other-month': !day.isCurrentMonth, 'current-month': day.isCurrentMonth, 'has-data': hasData(day.date), 'selected': isSelected(day.date) }]"
          @click="selectDay(day)"
        >
          {{ day.date ? day.date.getDate() : '' }}
          <span v-if="hasData(day.date)" class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(), // 当前显示的月份
      weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      enWeekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      // selectedDate: new Date(), // 默认选中当天
      // dataDates: ['2025-03-11', '2025-03-27', '2025-03-28'], // 有数据的日期
    };
  },
  props: {
    selectedDate: {
      type: Date,
      default: () => {
        return new Date()
      }
    },
    dataDates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentYear() {
      return this.currentDate.getFullYear();
    },
    currentMonth() {
      return this.currentDate.getMonth() + 1;
    },
    days() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);
      const daysInMonth = lastDayOfMonth.getDate();
      const startDay = firstDayOfMonth.getDay();

      const days = [];

      // 填充上个月的日期
      for (let i = startDay; i > 0; i--) {
        const date = new Date(year, month, -i + 1);
        days.push({ date: '', isCurrentMonth: false });
      }

      // 填充当前月的日期
      for (let i = 1; i <= daysInMonth; i++) {
        const date = new Date(year, month, i);
        days.push({ date, isCurrentMonth: true });
      }

      // 填充下个月的日期
      const endDay = lastDayOfMonth.getDay();
      for (let i = 1; i < 7 - endDay; i++) {
        const date = new Date(year, month + 1, i);
        days.push({ date: '', isCurrentMonth: false });
      }
      return days;
    }
  },
  methods: {
    // 切换到上一月
    prevMonth() {
      this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
      this.$emit('change-month', this.currentDate);
    },
    // 切换到下一月
    nextMonth() {
      this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
      this.$emit('change-month', this.currentDate);
    },
    // 选择日期
    selectDay(day) {
      if(day.date) {
        // this.selectedDate = day.date;
        this.$emit('select-day', day.date);
      }
    },
    // 判断日期是否有数据
    hasData(date) {
      if(date) {
        const dateString = new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().split('T')[0];
        return this.dataDates.includes(dateString);
      }
    },
    // 判断日期是否被选中
    isSelected(date) {
      if(date) {
        if (!this.selectedDate) return false;
        return (
          date.getFullYear() === this.selectedDate.getFullYear() &&
          date.getMonth() === this.selectedDate.getMonth() &&
          date.getDate() === this.selectedDate.getDate()
        );
      }
    },
    // 判断星期几是否被选中
    isSelectedWeekday(weekday) {
      if (!this.selectedDate) return false;
      // 只有选中的日期在当前月份时，才更新顶部星期几的选中状态
      if (
        this.selectedDate.getFullYear() === this.currentDate.getFullYear() &&
        this.selectedDate.getMonth() === this.currentDate.getMonth()
      ) {
        const selectedWeekday = this.weekdays[this.selectedDate.getDay()];
        return selectedWeekday === weekday;
      }
      return false;
    },
    // 切换月份时重置选中日期
    resetSelectedDate() {
      // this.selectedDate = null;
      this.$emit('select-day', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar {
  width: 100%;
  margin: 0 auto;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #F2F2F2;
  font-size: 16px;
  span {
    color: transparent; /* 使文字本身不可见 */
    background-image: linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%); /* 定义渐变颜色 */
    -webkit-background-clip: text; /* 针对WebKit浏览器 */
    background-clip: text; /* 使渐变仅应用于文字 */
  }
  .arrow {
    font-size: 22px;
    font-weight: bold;
  }
  .arrow-left {
    color: #EB1700;
  }
  .arrow-right {
    color: #BA3BBB;
  }
}

.calendar-body {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  padding: 0 6px;
}

.weekdays {
  display: flex;
  justify-content: space-around;
  padding: 14px 0px 6px;
}

.weekday {
  flex: 1;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  span {
    display: block;
  }
}

.weekday.selected {
  color: transparent; /* 使文字本身不可见 */
  background-image: linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%); /* 定义渐变颜色 */
  -webkit-background-clip: text; /* 针对WebKit浏览器 */
  background-clip: text; /* 使渐变仅应用于文字 */
}

.days {
  display: flex;
  flex-wrap: wrap;
}

.day {
  position: relative;
  width: calc(calc(100% / 7) - 16px);
  text-align: center;
  padding: 10px 0px;
  box-sizing: border-box;
  margin: 5px 8px;
  color: #CA001A;
}
.day.current-month {
  border: 1px solid #CA001A;
  border-radius: 14px;
}

.day.other-month {
  color: #ccc;
}

.day.selected {
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 85%, #8C3BBB 100%);
  color: white;
}


.day.has-data {
  position: relative;
  z-index: 9;
}

.dot {
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
  border-radius: 50%;
}
</style>